import { render, staticRenderFns } from "./ReportImageDamageDetail.vue?vue&type=template&id=056941f9"
import script from "./ReportImageDamageDetail.vue?vue&type=script&lang=ts"
export * from "./ReportImageDamageDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports